// extracted by mini-css-extract-plugin
export var categoryProduct = "a";
export var categoryProductImg = "b";
export var categoryProductImgColors = "c";
export var categoryProductName = "d";
export var categoryProductOrigin = "e";
export var categoryProductPriceCn = "f";
export var categoryProductPriceEn = "g";
export var categoryProductTag = "h";
export var categoryProductTagLine = "i";